import React from 'react'
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";

function NoShiftBar(props) {
  return (
    <div className="w-full bg-amber-50 border border-amber-200 px-4 py-4 rounded-xl flex flex-row items-center justify-center space-x-2">
      <WbSunnyOutlinedIcon sx={{ fontSize: 20, color: "#b45309" }} />
      <p className="text-amber-700 text-sm">
        {props.text}
      </p>
    </div>
  )
}

export default NoShiftBar
